import { createSlice } from '@reduxjs/toolkit'

const affiliazioniSlice = createSlice({
  name: 'affiliazioni',
  initialState: {},
  reducers: {
    setAffiliazione(state, action) {
      state.affiliazione = action.payload
    },
    setAffiliazioneField(state, action) {
      if (!state.affiliazione) state.affiliazione = {}
      state.affiliazione[action.payload.field] = action.payload.value
    },
  },
})

export const { setAffiliazione, setAffiliazioneField } =
  affiliazioniSlice.actions

export default affiliazioniSlice.reducer
